import type { DefaultApi, KomboApplicationStageTransitionRequest } from "@/api";
import { KomboApplicationStageTransition } from "@/models/kombo_application_stage_transition";
import { KomboApplicationStageTransitions } from "@/models/kombo_application_stage_transitions";
import type { State as RootState } from "@/stores";
import { type Module } from "vuex";
export interface State {}
export const module: Module<State, RootState> = {
  namespaced: true,
  actions: {
    async getStageTransitions({}, positionId: number) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getStageTransitions(positionId);
      return new KomboApplicationStageTransitions(
        response.data.map(
          (transition: Partial<KomboApplicationStageTransition>) =>
            new KomboApplicationStageTransition(transition),
        ),
      );
    },
    async postStageTransitions(
      {},
      {
        positionId,
        transitionRequest,
      }: {
        positionId: number;
        transitionRequest: KomboApplicationStageTransitionRequest[];
      },
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      await api.postStageTransitions(positionId, transitionRequest);
      return;
    },
  },
};
